import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormMessages } from './FormMessages';
import { SharedFormMessages as messages } from '../../shared/forms';

export const FormErrorMessages = props => (
  <FormMessages
    tagName="span"
    errorCount={1}
    field={props.field}
  >
    <span when="required" className="invalid-feedback d-inline-block"
      aria-describedby={props.ariaDescribedby || ''}
    >
      <FormattedMessage {...messages.error.required} />
    </span>
    <span when="min" className="invalid-feedback d-inline-block" aria-describedby={props.ariaDescribedby || ''} >
      {props.customMessage ? props.customMessage :
        <FormattedMessage values={{ min: props.min }} {...messages.error.min} />}
    </span>
    <span when="max" className="invalid-feedback d-inline-block" aria-describedby={props.ariaDescribedby || ''}>
      {props.customMessage ? props.customMessage :
        <FormattedMessage values={{ max: props.max }} {...messages.error.max} />}
    </span>
    <span when="minLength" className="invalid-feedback d-inline-block"
      aria-describedby={props.ariaDescribedby || ''}
    >
      {props.customMessage ? props.customMessage :
        <FormattedMessage values={{ minLength: props.minLength }} {...messages.error.minLength} />}
    </span>
    <span when="maxLength" className="invalid-feedback d-inline-block"
      aria-describedby={props.ariaDescribedby || ''}
    >
      {props.customMessage ? props.customMessage :
        <FormattedMessage values={{ maxLength: props.maxLength }} {...messages.error.maxLength} />}
    </span>
    <span when="email" className="invalid-feedback d-inline-block" aria-describedby={props.ariaDescribedby || ''}>
      {props.customMessage ? props.customMessage :
        <FormattedMessage {...(props.emailValidation || messages.error.email)} />}
    </span>
    <span when="matchField" className="invalid-feedback d-inline-block"
      aria-describedby={props.ariaDescribedby || ''}
    >
      {props.customMessage ? props.customMessage :
        <FormattedMessage {...messages.error.equalTo} />}
    </span>
    <span when="promise" className="invalid-feedback d-inline-block" aria-describedby={props.ariaDescribedby || ''}>
      {props.customMessage}
    </span>
  </FormMessages>);

FormErrorMessages.propTypes = {
  field: PropTypes.object.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  email: PropTypes.string,
  emailValidation: PropTypes.object,
  ariaDescribedby: PropTypes.string,
  customMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};
